import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'

import login from '@/views/login'

const home = () => import('@/views/home');

const docCatalogList = () => import('@/views/doccatalog/list');
const docCatalogEdit = () => import('@/views/doccatalog/edit');

const docInList = () => import('@/views/docin/list');
const docInEdit = () => import('@/views/docin/edit');

const docOutList = () => import('@/views/docout/list');
const docOutEdit = () => import('@/views/docout/edit');
const docOutInfo = () => import('@/views/docout/info');

const docList = () => import('@/views/doc/list');
const docFeedbackList = () => import('@/views/doc/feedbacklist');
const docFeedback = () => import('@/views/doc/feedback');
const docInfo = () => import('@/views/doc/info');

const docReceiveList = () => import('@/views/docreceive/list');
const docReceiveEdit = () => import('@/views/docreceive/edit');
const docReceiveInfo = () => import('@/views/docreceive/info');

const docStatStock = () => import('@/views/docstat/stock');
const docStatUse = () => import('@/views/docstat/use');

const caseAdd = () => import('@/views/case/add');
const caseAddList = () => import('@/views/case/addlist');
const caseReceiveList = () => import('@/views/case/receivelist');
const caseList = () => import('@/views/case/list');
const caseDetails = () => import('@/views/case/details');

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/',
      name: 'home',
      component: home,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/doccatalog/list',
          name: 'doccataloglist',
          component: docCatalogList,
          meta: {
            keepAlive: true,
            requiresAuth: true
          }
        },
        {
          path: '/doccatalog/edit',
          name: 'doccatalogedit',
          component: docCatalogEdit,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/docin/list',
          name: 'docinlist',
          component: docInList,
          meta: {
            keepAlive: true,
            requiresAuth: true
          }
        },
        {
          path: '/docin/edit',
          name: 'docinedit',
          component: docInEdit,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/docout/list',
          name: 'docoutlist',
          component: docOutList,
          meta: {
            keepAlive: true,
            requiresAuth: true
          }
        },
        {
          path: '/docout/edit',
          name: 'docoutedit',
          component: docOutEdit,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/docout/info',
          name: 'docoutinfo',
          component: docOutInfo,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/docreceive/list',
          name: 'docreceivelist',
          component: docReceiveList,
          meta: {
            keepAlive: true,
            requiresAuth: true
          }
        },
        {
          path: '/docreceive/edit',
          name: 'docreceiveedit',
          component: docReceiveEdit,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/docreceive/info',
          name: 'docreceiveinfo',
          component: docReceiveInfo,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/docstat/stock',
          name: 'docstatstock',
          component: docStatStock,
          meta: {
            keepAlive: true,
            requiresAuth: true
          }
        },
        {
          path: '/docstat/use',
          name: 'docstatuse',
          component: docStatUse,
          meta: {
            keepAlive: true,
            requiresAuth: true
          }
        },
        {
          path: '/doc/list',
          name: 'doclist',
          component: docList,
          meta: {
            keepAlive: true,
            requiresAuth: true
          }
        },
        {
          path: '/doc/feedbacklist',
          name: 'docfeedbacklist',
          component: docFeedbackList,
          meta: {
            keepAlive: true,
            requiresAuth: true
          }
        },
        {
          path: '/doc/feedback',
          name: 'docfeedback',
          component: docFeedback,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/doc/info',
          name: 'docinfo',
          component: docInfo,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/case/addlist',
          name: 'caseaddlist',
          component: caseAddList,
          meta: {
            keepAlive: true,
            requiresAuth: true
          }
        },
        {
          path: '/case/receivelist',
          name: 'casereceivelist',
          component: caseReceiveList,
          meta: {
            keepAlive: true,
            requiresAuth: true
          }
        },
        {
          path: '/case/list',
          name: 'caselist',
          component: caseList,
          meta: {
            keepAlive: true,
            requiresAuth: true
          }
        },
        {
          path: '/case/add',
          name: 'caseadd',
          component: caseAdd,
          meta: { requiresAuth: true }
        },
        {
          path: '/case/details',
          name: 'casedetails',
          component: caseDetails,
          meta: { requiresAuth: true }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    // 判断该路由是否需要登录权限
    if (Cookies.get('Token')) {
      next();
    } else {
      Cookies.remove('Token');
      Cookies.remove('Account');
      Cookies.remove('DisplayName');
      Cookies.remove('UserRoleIds');
      next({
        name: 'login',
        query: {
          redirect: to.fullPath
        }
      })
      // window.top.location.reload();
      // window.top.location.href = 'login';
    }
  } else {
    next();
  }
});

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js